import {AppNotification, NotificationMarkType} from '../../types/notifications.types';
import {ActionMenu, DeleteActionItem, NotificationActionItem} from '../notifications.styles';

interface NotificationActionsMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  selectedNotification: AppNotification | null;
  loading: boolean;
  onMarkNotification: (markType: NotificationMarkType) => Promise<void>;
  onClose: () => void;
  onExited: () => void;
}

export const NotificationActionsMenu = ({
  anchorEl,
  open,
  selectedNotification,
  loading,
  onMarkNotification,
  onClose,
  onExited,
}: NotificationActionsMenuProps) => {
  const handleNotificationAction = (markType: NotificationMarkType) => () => {
    void onMarkNotification(markType);
  };

  return (
    <ActionMenu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      PaperProps={{sx: {width: 183}}}
      TransitionProps={{onExited}}
    >
      {selectedNotification && (
        <>
          {selectedNotification.markType !== 'NEW' && (
            <NotificationActionItem onClick={handleNotificationAction('NEW')} disabled={loading}>
              Пометить новым
            </NotificationActionItem>
          )}
          {selectedNotification.markType !== 'READ' && (
            <NotificationActionItem onClick={handleNotificationAction('READ')} disabled={loading}>
              Пометить прочитанным
            </NotificationActionItem>
          )}
          <DeleteActionItem onClick={handleNotificationAction('DELETE')} disabled={loading}>
            Удалить
          </DeleteActionItem>
        </>
      )}
    </ActionMenu>
  );
};
